import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'gtw-workspace-not-assigned',
    templateUrl: './workspace-not-assigned.component.html',
    styleUrls: ['./workspace-not-assigned.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class WorkspaceNotAssignedComponent {}
